import { Stack } from "@mui/material";
import type { FC } from "react";
import { ActivitiesListSectionSkeleton } from "web_myplann/Activities/Components/ActivitiesListSectionSkeleton";
import { ACTIVITY_SKELETON_SECTIONS } from "web_myplann/Activities/constants";

export const ActivitiesListSkeleton: FC = () => (
	<Stack data-testid="activities-list-skeleton">
		{ACTIVITY_SKELETON_SECTIONS.map(({ id, rowKeys }) => (
			<ActivitiesListSectionSkeleton key={id} rowKeys={rowKeys} />
		))}
	</Stack>
);
